
<div class="login-page">
  <form [formGroup]="formGroup" class="login-form">
    <p-card header="Accesso" styleClass="login-card">
      <ng-template pTemplate="header">
        <div class="login-logo-container">
          <img
            alt="LOGO FAISA CISAL"
            class="login-logo"
            src="./assets/logos/faisa-cisal-logo.svg"
          />
        </div>
      </ng-template>

      <div id="login">
        <div id="container-login">
          <span class="p-float-label login-input-row">
            <input
              id="email"
              formControlName="email"
              [(ngModel)]="loginDto.email"
              type="text"
              pInputText
            />
            <label for="email">Email</label>
          </span>

          <span class="p-float-label login-input-row">
            <input
              id="password"
              formControlName="password"
              [(ngModel)]="loginDto.password"
              type="password"
              pInputText
            />
            <label for="password">Password</label>
          </span>
        </div>
      </div>

      <ng-template pTemplate="footer">
        <div class="login-actions">
          <p-button
            [style]="{ width: '100%' }"
            [disabled]="!formGroup.valid"
            (onClick)="loginClick()"
            pRipple
            label="Accedi"
            icon="pi pi-user"
            styleClass="w-full"
          ></p-button>

          <p-button
            severity="secondary"
            [style]="{ width: '100%' }"
            [outlined]="true"
            label="Password dimenticata"
            (onClick)="showForgotten = true"
            styleClass="w-full"
          ></p-button>

          <p-button
            severity="secondary"
            [style]="{ width: '100%' }"
            [outlined]="true"
            label="Primo accesso"
            (onClick)="showFirstAccess = true"
            styleClass="w-full"
          ></p-button>

          <p-button
            severity="secondary"
            [style]="{ width: '100%' }"
            [outlined]="true"
            label="Info Page"
            [routerLink]="['/infoPage']"
            styleClass="w-full"
          ></p-button>
        </div>
      </ng-template>
    </p-card>
  </form>
</div>

<p-dialog
  [closable]="false"
  [visible]="showForgotten"
  [draggable]="false"
  [modal]="true"
  [closeOnEscape]="true"
  #cd
>
  <ng-template pTemplate="header">
    <h2>Password dimenticata</h2>
  </ng-template>

  <div>
    Se hai dimenticato la tua password, puoi contattare il servizio tecnico
    ai seguenti contatti:

    <ul>
      <li>Numero Whatsapp: 3534613832</li>
      <li>Email: tecnico.faisacisal.pistoia@gmail.com</li>
    </ul>

    Invia una mail o scrivi un messaggio Whatsapp, risponderemo il prima possibile.
  </div>

  <ng-template pTemplate="footer">
    <p-button
      icon="pi pi-check"
      label="Ok"
      (onClick)="showForgotten = false"
    ></p-button>
  </ng-template>
</p-dialog>

<p-dialog
  [closable]="false"
  [visible]="showFirstAccess"
  [draggable]="false"
  [modal]="true"
  [closeOnEscape]="true"
  #cd
>
  <ng-template pTemplate="header">
    <h2>Primo accesso</h2>
  </ng-template>

  <div>
    Se quello che stai per eseguire è il tuo primo accesso,
    ricordati di inserire la password che ti è stata fornita.
    Attenzione ai caratteri speciali, alle maiuscole e alle minuscole.
  </div>

  <ng-template pTemplate="footer">
    <p-button
      icon="pi pi-check"
      label="Ok"
      (onClick)="showFirstAccess = false"
    ></p-button>
  </ng-template>
</p-dialog>